<!-- src/app/application-submitted/application-submitted.component.html -->
<div class="container d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light">
    <div class="card shadow-lg p-5 text-center" style="max-width: 500px; width: 100%; border-radius: 15px;">
      <div class="card-body">
        <h2 class="mb-4 bigTitleCol">
          <i class="bi bi-check-circle-fill me-2"></i> {{ 'APPLICATION_SUBMITTED.TITLE' | translate }}
        </h2>
        <p class="card-text mb-3 fs-5">
          {{ 'APPLICATION_SUBMITTED.MESSAGE' | translate }}
        </p>
        <button type="button" class="btn button-primary-purple btn-lg w-55" (click)="backToLogin()">
          {{ 'APPLICATION_SUBMITTED.BACK_TO_LOGIN_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
  

  